import '@fontsource/cabin';
import '@fontsource/cabin/500.css';
import '@fontsource/cabin/700.css';
import FontFaceObserver from 'fontfaceobserver';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './styles/raleway-rt.scss';
import './styles/chat.scss';

const root = createRoot(document.getElementById('root')!);

// These are the fonts needed for the welcome page and they cause FOUT if we do not block on their loading
const raleway500 = new FontFaceObserver('RT Raleway', { weight: 500 });
const raleway600 = new FontFaceObserver('RT Raleway', { weight: 600 });
const cabin400 = new FontFaceObserver('Cabin', { weight: 400 });
const cabin700 = new FontFaceObserver('Cabin', { weight: 700 });

Promise.all([
  raleway500.load(),
  raleway600.load(),
  cabin400.load(),
  cabin700.load(),
])
  .then(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  })
  .catch(() => {
    // if anything goes wrong just render the app anyway without the fonts
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
